import React from 'react';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDatabase, faAsterisk,faSignOutAlt, faChartArea, faCalendarAlt} from '@fortawesome/free-solid-svg-icons'




import { BrowserRouter as Router, Route} from "react-router-dom";

import Board from './Board';



import UploadList from '../UploadList/UploadList';
import AddCollector from '../AddCollector/AddCollector';
import AddChild from '../AddChild/AddChild';
import AddClass from '../AddClass/AddClass';

import ChangeChildDetails from '../ChangeChildDetails/ChangeChildDetails';
import ChangeClassDetails from '../ChangeClassDetails/ChangeClassDetails';
import ChangeCollectorDetails from '../ChangeCollectorDetails/ChangeCollectorDetails';


import DailyReport from '../DailyReport/DailyReport';
import ChildDetail from '../ChildDetail/ChildDetail';
import CollectorDetail from '../CollectorDetail/CollectorDetail';
import Allergy from '../Allergy/Allergy';
import Summary from '../Summary/Summary';
import ExportData from '../ExportData/ExportData';

import CreateEvent from '../FMK-EVENTS/CreateEvent';
import SchoolEvents from '../FMK-EVENTS/SchoolEvents';
import Indemnities from '../FMK-EVENTS/Indemnities';


import SideNav, {  NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';

import '@trendmicro/react-sidenav/dist/react-sidenav.css';


import './DashBoard.css';

class DashBoard extends React.Component{





logOut = () =>{

  //return this.props.isLogedIn(false);

  window.location.replace("https://za-ad-fetch-my-kid.web.app");
}


  render(){



    return(
<div>
<Router>
  <Route render={({ location, history }) => (
      <React.Fragment>
          <SideNav
              onSelect={(selected) => {
                  const to = '/' + selected;
                  if (location.pathname !== to) {
                      history.push(to);
                  }
              }}
          >
              <SideNav.Toggle />
              <SideNav.Nav defaultSelected="" style={{height:'100%'}}>
                  <NavItem eventKey="">
                      <NavIcon>
                          <FontAwesomeIcon icon={faAsterisk} />
                      </NavIcon>
                      <NavText>
                          DashBoard
                      </NavText>
                  </NavItem>




                  <NavItem eventKey="fmkevents">
                      <NavIcon>
                          <FontAwesomeIcon icon={faCalendarAlt} />
                      </NavIcon>
                      <NavText>
                          Activities/Events
                      </NavText>

                      <NavItem eventKey="create-activity-or-event">
                      <NavText>
                          Create Event / Activity
                      </NavText>
                      </NavItem>


                      <NavItem eventKey="view-events">
                      <NavText>
                         Events / Activities
                      </NavText>
                      </NavItem>

                      <NavItem eventKey="view-Indemnities">
                      <NavText>
                         Indemnities
                      </NavText>
                      </NavItem>


                  </NavItem>




                  <NavItem eventKey="reports">
                      <NavIcon>
                        <FontAwesomeIcon icon={faChartArea} />
                      </NavIcon>
                      <NavText>
                          Reports
                      </NavText>

                      <NavItem eventKey="daily_report">
                      <NavText>
                          Report
                      </NavText>
                      </NavItem>

                      <NavItem eventKey="child_detail">
                      <NavText>
                          Child Detail
                      </NavText>
                      </NavItem>

                      <NavItem eventKey="collector_detail">
                      <NavText>
                          Collector Detail
                      </NavText>
                      </NavItem>

                      <NavItem eventKey="allergy_detail">
                      <NavText>
                          Allergies
                      </NavText>
                      </NavItem>

                      <NavItem eventKey="summary">
                      <NavText>
                          Summary
                      </NavText>
                      </NavItem>

                      <NavItem eventKey="export_data">
                      <NavText>
                          Export Data
                      </NavText>
                      </NavItem>

                  </NavItem>


                  <NavItem eventKey="data">
                      <NavIcon>
                          <FontAwesomeIcon icon={faDatabase} />
                      </NavIcon>
                      <NavText>
                          Data
                      </NavText>

                      <NavItem eventKey="upload_list">
                      <NavText>
                          Upload List
                      </NavText>
                      </NavItem>

                      <NavItem eventKey="add_collector">
                      <NavText>
                          Add Collector
                      </NavText>
                      </NavItem>

                      <NavItem eventKey="add_child">
                      <NavText>
                          Add Child
                      </NavText>
                      </NavItem>


                      <NavItem eventKey="add_class">
                      <NavText>
                          Add Class
                      </NavText>
                      </NavItem>


                      <NavItem eventKey="change_child_details">
                      <NavText>
                          Change Child Details
                      </NavText>
                      </NavItem>

                      <NavItem eventKey="change_class_details">
                      <NavText>
                          Change Class Details
                      </NavText>
                      </NavItem>

                      <NavItem eventKey="change_collector_details">
                      <NavText>
                          Change Collector Details
                      </NavText>
                      </NavItem>



                  </NavItem>

                  <NavItem onClick={this.logOut}>
                  <NavIcon>
                      <FontAwesomeIcon icon={faSignOutAlt } />
                  </NavIcon>
                  <NavText>
                      Log out
                  </NavText>
                  </NavItem>





              </SideNav.Nav>
          </SideNav>
          <main>



          <Route
            exact path='/'
            render={(props) => <Board {...props} isAuthed={true} />}
          />


          <Route
            exact path='/upload_list'
            render={(props) => <UploadList {...props} isAuthed={true} />}
          />

          <Route
            exact path='/add_collector'
            render={(props) => <AddCollector {...props} isAuthed={true} />}
          />

          <Route
            exact path='/add_child'
            render={(props) => <AddChild {...props} isAuthed={true} />}
          />

          <Route
            exact path='/add_class'
            render={(props) => <AddClass {...props} isAuthed={true} />}
          />

          <Route
            exact path='/change_child_details'
            render={(props) => <ChangeChildDetails {...props} isAuthed={true} />}
          />

          <Route
            exact path='/change_class_details'
            render={(props) => <ChangeClassDetails {...props} isAuthed={true} />}
          />

          <Route
            exact path='/change_collector_details'
            render={(props) => <ChangeCollectorDetails {...props} isAuthed={true} />}
          />

          <Route
            exact path='/daily_report'
            render={(props) => <DailyReport {...props} isAuthed={true} />}
          />

          <Route
            exact path='/child_detail'
            render={(props) => <ChildDetail {...props} isAuthed={true} />}
          />

          <Route
            exact path='/collector_detail'
            render={(props) => <CollectorDetail {...props} isAuthed={true} />}
          />


          <Route
            exact path='/allergy_detail'
            render={(props) => <Allergy {...props} isAuthed={true} />}
          />

          <Route
            exact path='/summary'
            render={(props) => <Summary {...props} isAuthed={true} />}
          />


          <Route
            exact path='/export_data'
            render={(props) => <ExportData {...props} isAuthed={true} />}
          />


          <Route
            exact path='/create-activity-or-event'
            render={(props) => <CreateEvent {...props} isAuthed={true} />}
          />


          <Route
            exact path='/view-events'
            render={(props) => <SchoolEvents {...props} isAuthed={true} />}
          />

          <Route
            exact path='/view-Indemnities'
            render={(props) => <Indemnities {...props} isAuthed={true} />}
          />




          </main>
      </React.Fragment>
  )}
  />
</Router>
</div>





    )
  }
}

export default DashBoard;



// WEBPACK FOOTER //
// ./src/components/DashBoard/DashBoard.js